declare var rpb2bGlobalConfig: any;

let REACT_APP_BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
let REACT_APP_BASE_WORDPRESS_URL = process.env.REACT_APP_BASE_WORDPRESS_URL;
let REACT_APP_ENABLE_VERIFY_ACCOUNT =
  process.env.REACT_APP_ENABLE_VERIFY_ACCOUNT;
let REACT_APP_BASE_ENVIRONMENT = process.env.REACT_APP_BASE_ENVIRONMENT;
let REACT_APP_PAYSIMPLE_URL = process.env.REACT_APP_PAYSIMPLE_URL;
let REACT_APP_INVOICE_CC_PAYMENT = process.env.REACT_APP_INVOICE_CC_PAYMENT;
let REACT_APP_CREDIT_CC_CARD = process.env.REACT_APP_CREDIT_CC_CARD;

try {
  if (rpb2bGlobalConfig != null) {
    REACT_APP_BASE_API_URL = rpb2bGlobalConfig.REACT_APP_BASE_API_URL
      ? rpb2bGlobalConfig.REACT_APP_BASE_API_URL
      : REACT_APP_BASE_API_URL;
    REACT_APP_BASE_WORDPRESS_URL = rpb2bGlobalConfig.REACT_APP_BASE_WORDPRESS_URL
      ? rpb2bGlobalConfig.REACT_APP_BASE_WORDPRESS_URL
      : REACT_APP_BASE_WORDPRESS_URL;
    REACT_APP_ENABLE_VERIFY_ACCOUNT = rpb2bGlobalConfig.REACT_APP_ENABLE_VERIFY_ACCOUNT
      ? rpb2bGlobalConfig.REACT_APP_ENABLE_VERIFY_ACCOUNT
      : REACT_APP_ENABLE_VERIFY_ACCOUNT;
    REACT_APP_BASE_ENVIRONMENT = rpb2bGlobalConfig.REACT_APP_BASE_ENVIRONMENT
      ? rpb2bGlobalConfig.REACT_APP_BASE_ENVIRONMENT
      : REACT_APP_BASE_ENVIRONMENT;

    REACT_APP_PAYSIMPLE_URL = rpb2bGlobalConfig.REACT_APP_PAYSIMPLE_URL
      ? rpb2bGlobalConfig.REACT_APP_PAYSIMPLE_URL
      : REACT_APP_PAYSIMPLE_URL;

    REACT_APP_INVOICE_CC_PAYMENT = rpb2bGlobalConfig.REACT_APP_INVOICE_CC_PAYMENT
      ? rpb2bGlobalConfig.REACT_APP_INVOICE_CC_PAYMENT
      : REACT_APP_INVOICE_CC_PAYMENT;

    REACT_APP_CREDIT_CC_CARD = rpb2bGlobalConfig.REACT_APP_CREDIT_CC_CARD
      ? rpb2bGlobalConfig.REACT_APP_CREDIT_CC_CARD
      : REACT_APP_CREDIT_CC_CARD;
  }
} catch (err) {
  console.error(err);
}

export const env = {
  REACT_APP_BASE_API_URL,
  REACT_APP_BASE_WORDPRESS_URL,
  REACT_APP_ENABLE_VERIFY_ACCOUNT,
  REACT_APP_BASE_ENVIRONMENT,
  REACT_APP_PAYSIMPLE_URL,
  REACT_APP_INVOICE_CC_PAYMENT,
  REACT_APP_CREDIT_CC_CARD
};

export default env;
